import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_DRIVER_JOB, ROUTE_DRIVER_JOB_SIGN_IN } from '../shared/routes';
import { ROUTE_FORGOT_PASSWORD } from '../../forgot-password/shared/routes';

@Component({
    selector: 'app-sign-up-completed',
    templateUrl: './sign-up-completed.component.html',
    styleUrls: ['./sign-up-completed.component.scss'],
    standalone: false
})
export class SignUpCompletedComponent implements OnInit {
  isFromCarrier = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    // Check if the fromCarrier query parameter is true
    const fromCarrierParam = this.activatedRoute.snapshot.queryParams['fromCarrier'];
    this.isFromCarrier = fromCarrierParam === 'true' || fromCarrierParam === true;
  }

  goToSignIn(): void {
    this.router.navigate([`/${ROUTE_DRIVER_JOB}`, ROUTE_DRIVER_JOB_SIGN_IN]);
  }

  goToResetPassword(): void {
    this.router.navigate([`/${ROUTE_FORGOT_PASSWORD}`]);
  }
}
